export default {
    props: {
        users: {
            type: Array,
            required: true
        },
        count: {
            type: Number,
            required: false,
            default: 0
        }
    },

    data() {
        return {
            params: {
                page: 1,
                perPage: null,
                query: null,
                sortBy: null,
                order: null
            }
        };
    },

    components: {
        employeeList: () => import('@/components/EmployeeList')
    },

    watch: {
        params: {
            handler(params) {
                this.$emit('findUsers', params);
            },
            deep: true
        }
    },

    methods: {
        onUpdateTable({
            itemsPerPage,
            page,
            query,
            sortBy: [sortBy],
            sortDesc: [sortDesc]
        }) {
            this.params.perPage = itemsPerPage;
            this.params.page = page;

            if (sortBy) {
                this.params.sortBy = sortBy;
            } else {
                this.params.sortBy = null;
            }

            if (typeof sortDesc === 'boolean') {
                this.params.order = sortDesc ? 'DESC' : 'ASC';
            } else {
                this.params.order = null;
            }

            if (query === '' || query === null) {
                this.params.query = null;
                this.params.page = 1;

                return;
            }

            if (query) {
                this.params.query = query;
                this.params.page = 1;
            }
        },

        onRefresh() {
            this.$emit('findUsers', this.params);
        }
    }
};
